import "core-js/modules/es.array.push.js";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive } from "vue";
import moment from "moment";
import { contractTypeMap } from "../../util/type";
import { phoneDesc, isPhoneNumber, EncryptName } from "../../util/index";
import { ElMessage } from "element-plus";
export default {
  name: "mycontract",
  components: {},
  setup() {
    const router = useRouter();
    const route = useRoute();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      page: 1,
      //当前页数
      size: 10,
      //一页几条
      total: 0,
      //共几条
      pages: 0,
      //一共几页
      list: [],
      url: "",
      base64Str: "",
      protocolVisible: false
    });
    onMounted(() => {
      selectContractList();
    });
    const selectContractList = async () => {
      const params = {
        page: data.page,
        size: data.size
      };
      var res = await globalProperties.$api.contractList(params);
      data.list = res.records;
      data.page = res.current;
      data.total = res.total;
      data.pages = res.pages;
    };
    const currentChange = page => {
      data.page = page;
      selectContractList();
    };
    const toViewContract = async record => {
      const {
        contractId,
        contractFile
      } = record;
      var res = await globalProperties.$api.contractFileInfo(contractId);
      if (res) {
        data.base64Str = "data:image/png;base64," + res;
        data.protocolVisible = true;
      } else {
        ElMessage({
          message: "合同生成中，请稍后查看",
          type: "warning"
        });
      }
    };
    const toDownload = async record => {
      const {
        contractFile
      } = record;
      var a = document.createElement("a");
      a.href = contractFile;
      a.click();
    };
    const viewOrderDetail = orderId => {
      router.push({
        path: "/layout/orderdetail",
        query: {
          orderId
        }
      });
    };
    return {
      data,
      moment,
      contractTypeMap,
      toViewContract,
      toDownload,
      currentChange,
      viewOrderDetail,
      phoneDesc,
      isPhoneNumber,
      EncryptName
    };
  }
};